import { connect } from 'react-redux';

import { GridActionsMenu, GridActionsMenuProps } from '../../components/GridActionsMenu/GridActionsMenu';
import { minusPhraseLibraryActionsMenuSelector } from '../../selectors/minusPhraseLibrary/minusPhraseLibrary';
import { Bem } from '../../service/Bem/Bem';
import { MinusPhraseLibraryActions } from '../../typings/minusPhraseLibrary';
import { State } from '../../typings/state';

import './MinusPhraseLibraryMenuActionsContainer.css';

export interface MinusPhraseLibraryMenuActionsContainerProps {
    index: number;
    actions: MinusPhraseLibraryActions;
}

const mapStateToPropsForGrid = (
    state: State,
    ownProps: MinusPhraseLibraryMenuActionsContainerProps
): GridActionsMenuProps => {
    const { actions, events } = minusPhraseLibraryActionsMenuSelector(state, ownProps);

    return {
        actions,
        events,
        cls: Bem.cls('minus-phrase-library-menu-actions')
    };
};

const mergeProps = (stateProps: GridActionsMenuProps): GridActionsMenuProps => {
    return stateProps;
};

export const MinusPhraseLibraryActionsMenuContainer = connect<
    GridActionsMenuProps,
    {},
    MinusPhraseLibraryMenuActionsContainerProps,
    GridActionsMenuProps
>(
    mapStateToPropsForGrid,
    undefined,
    mergeProps
)(GridActionsMenu);
